
import PrimaryButton from '@/components/shared/PrimaryButton';
import { backendExceptionHandler } from "@/mixins";
import FinAgentService from '@/service/FinAgentService';
import _ from 'lodash';

export default {
    name: "EditSnippetTitleModal",

    components: {
        PrimaryButton,
    },

    mixins: [backendExceptionHandler],
    
    props: {
        snippet: {
            type: Object,
            default: null,
        },
        value: {
            type: Boolean,
            default: false,
        }
    },

    emits: ['input', 'success'],

    data() {
        return {
            snippetTitle: '',
            errorMessage: null,
            isLoading: false,
            rules: {
                required: value => !!value?.trim() || this.$t('components.finAgentSnippet.titleRequired'),
            }
        }
    },

    computed: {
        isSubmitDisabled() {
            return this.isLoading || !this.snippetTitle.trim() || this.snippetTitle.trim() === this.snippet.title;
        }
    },
    
    watch: {
        snippet(data) {            
            this.snippetTitle = data?.title;
        }
    },

    created() {
        this.finAgentService = new FinAgentService(this.$axios);
        this.debouncedSubmit = _.debounce(this.handleSubmit, 300); 
    },

    methods: {
        closeModal() {
            this.$emit('input', false);
        },

        async handleSubmit() {
            if (this.isSubmitDisabled) {
                return;
            }

            try {
                await this.finAgentService.updateSnippetTitle(this.snippet.id, this.snippetTitle);
                this.$emit('success', { id: this.snippet.id, newTitle: this.snippetTitle });
                this.$store.commit('snackbar/updateType', 'success');
                this.$store.commit('snackbar/updateMessage', this.$t('component.snippetEditTitleModal.success'));
                this.closeModal();
            } catch (error) {
                this.handleBackendException(error, this.$t('component.snippetEditTitleModal.error'));
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.errorMessage);
            }
        },
    },
}
